// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#widget-container .wrapper {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 460px;
  height: 100%;
  overflow: hidden;
  transition: width 0.3s ease-in-out;
  z-index: 100;
  background: var(--Neutral-Neutral-5, #f2f2f2);
  box-shadow: -5px 0px 18px 0px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}

#widget-container .header-top {
  width: 100%;
  height: 103px;
  background-position: top;
  background-repeat: no-repeat;
  padding: 1rem 2rem;
  box-sizing: border-box;
  display: flex;
}
#widget-container .header-wrapper {
  display: flex;
  gap: 1rem;
}

#widget-container .text-overlay {
  color: var(--Text-Color-Default, #333);
  font-family: "McKinseySans-Regular", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}
#widget-container .button {
  background: none;
  border: none;
  top: 1rem;
  position: absolute;
  right: 1rem;
  cursor: pointer;
}
#widget-container .chat-content {
  flex: 1;
  overflow-y: auto;
  height: 65%;
  /* padding: 1rem; */
}
#widget-container .footer {
  position: fixed;
  bottom: 0;
  text-align: center;
  width: 460px;
  display: flex;
  justify-content: center;
  gap: 8px;
}
#widget-container .prompt-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
}
#widget-container .input-container {
  position: fixed;
  bottom: 48px;
  width: 460px;
  padding: 0 20px;
  display: flex;
  box-sizing: border-box;
  gap: 12px;
}
#widget-container .app-logo {
  width: 32px;
  height: 32px;
}
`, "",{"version":3,"sources":["webpack://./src/components/chatbot/styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;EACZ,6CAA6C;EAC7C,iDAAiD;EACjD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,+CAA+C;EAC/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":["#widget-container .wrapper {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  width: 460px;\n  height: 100%;\n  overflow: hidden;\n  transition: width 0.3s ease-in-out;\n  z-index: 100;\n  background: var(--Neutral-Neutral-5, #f2f2f2);\n  box-shadow: -5px 0px 18px 0px rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n}\n\n#widget-container .header-top {\n  width: 100%;\n  height: 103px;\n  background-position: top;\n  background-repeat: no-repeat;\n  padding: 1rem 2rem;\n  box-sizing: border-box;\n  display: flex;\n}\n#widget-container .header-wrapper {\n  display: flex;\n  gap: 1rem;\n}\n\n#widget-container .text-overlay {\n  color: var(--Text-Color-Default, #333);\n  font-family: \"McKinseySans-Regular\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 32px;\n}\n#widget-container .button {\n  background: none;\n  border: none;\n  top: 1rem;\n  position: absolute;\n  right: 1rem;\n  cursor: pointer;\n}\n#widget-container .chat-content {\n  flex: 1;\n  overflow-y: auto;\n  height: 65%;\n  /* padding: 1rem; */\n}\n#widget-container .footer {\n  position: fixed;\n  bottom: 0;\n  text-align: center;\n  width: 460px;\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n}\n#widget-container .prompt-container {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  gap: 12px;\n}\n#widget-container .input-container {\n  position: fixed;\n  bottom: 48px;\n  width: 460px;\n  padding: 0 20px;\n  display: flex;\n  box-sizing: border-box;\n  gap: 12px;\n}\n#widget-container .app-logo {\n  width: 32px;\n  height: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
